import { render, staticRenderFns } from "./ProgramAppelDeFondsItem.vue?vue&type=template&id=57388efd&"
import script from "./ProgramAppelDeFondsItem.vue?vue&type=script&lang=js&"
export * from "./ProgramAppelDeFondsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports